import { createI18n } from 'vue-i18n';

/**
 * Determine the initial locale.
 * During prerendering (no window/localStorage), default to 'fi' to ensure
 * consistent HTML output and prevent hydration mismatches.
 * After hydration, the locale is updated from localStorage in onMounted.
 */
const getInitialLocale = (): string => {
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return 'fi';
  }

  return localStorage.getItem('sovi-locale') || 'fi';
};

const i18n = createI18n({
  locale: getInitialLocale(),
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    fi: {},
    en: {},
  },
});

export default i18n;
